<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .menu-generic
        box-sizing: border-box
        position: absolute
        width: 100%
        z-index: 3

        &__container
            display: flex
            +media("<=phone")
                display: none

            &__left
                padding: 8rem 5rem 0 0
                flex-basis: calc(50% - 15rem)
                // background: $color-base-dark
                background: transparentize($color-base2, 0.2)
                height: 40rem
                box-sizing: border-box
                display: flex
                justify-content: flex-end
                z-index: 2
                position: relative
                +media("<=1024px")
                    padding: 8rem 0 0 0

                .sticky &
                    background: $color-base-dark

                &__content
                    width: 22rem
                    padding-right: 5rem

                &__text
                    padding: 1.5rem 1rem
                    &.text--1
                        color: white

                &__links
                    a
                        display: block
                        padding: 1.5rem 1rem
                        border-bottom: 1px solid rgba(255,255,255,0.5)
                        color: white
                        position: relative
                        transition: all $speed-fast $authentic-motion
                        cursor: pointer

                        &:after
                            content: ''
                            background-image: url(../../common/graphics/arrow-down.svg)
                            display: block
                            position: absolute
                            width: 1rem
                            height: 1rem
                            right: 1rem
                            top: calc(50% - 0.5rem)
                            filter: brightness(0) invert(1)
                            transition: transform $speed-fast $authentic-motion
                            transform: rotate(-90deg)

                        &:last-child
                            border-bottom: 0

                        &:hover:after
                            transform: translateX(0.5rem) rotate(-90deg)

                        &.active
                            color: $color-base
                            background: white
                            &:after
                                color: $color-base
                                transform: none

            &__right
                flex-basis: calc(50% + 15rem)
                height: 40rem
                display: flex
                position: relative
                &:after
                    content: ""
                    position: absolute
                    width: 100%
                    height: 100%
                    background: transparentize($color-base, 0.2)
                    transition: transform $speed-normal $authentic-motion, opacity $speed-normal $authentic-motion
                    pointer-events: none
                    transform: scaleX(0)
                    transform-origin: 0 0
                    z-index: 0

                &.show:after
                    opacity: 1
                    transform: none

                &__wrapper
                    position: absolute
                    width: 100%
                    height: 100%
                    pointer-events: none

                    &.show-content
                        pointer-events: all

                    //&:after
                        +pseudo
                        background: black
                        opacity: 0.2

                &__content
                    position: relative
                    z-index: 2
                    margin-top: 10rem
                    margin-left: 5rem
                    opacity: 0
                    transform: translateX(-1rem)
                    transition: transform $speed-fast $authentic-motion, opacity $speed-fast $authentic-motion
                    height: calc(100% - 10rem)
                    +media("<=1024px")
                        margin-left: 2rem

                    .show-content &
                        opacity: 1
                        transform: none

                .el-icon-close
                    color: white
                    cursor: pointer
                    width: 2rem
                    height: 2rem

                &__links
                    height: calc(100% - 2rem)
                    max-width: 50rem
                    +media("<=1024px")
                        max-width: 95%

                    &--column
                        column-count: 2

                    a
                        display: block
                        color: white
                        margin-bottom: 1.5rem
                        transition: transform $speed-fast $authentic-motion-in, opacity $speed-fast $authentic-motion-in
                        opacity: 0
                        transform: translateX(-25%)
                        .show-content &
                            transition: transform $speed-fast $authentic-motion-out, opacity $speed-fast $authentic-motion-out
                            opacity: 1
                            transform: none
                            @for $i from 1 through 20
                                &:nth-child(#{$i})
                                    transition-delay: 15ms * $i

                &__section
                    height: 100%
                    display: inline-block
                    vertical-align: top
                    width: 14rem
                    +media("<=1024px")
                        width: 11rem
                    &__title
                        color: white
                        margin-bottom: 2.5rem
                        font-weight: 400
                        font-size: 1.2rem
                        position: relative
                        &:after
                            position: absolute
                            content: ""
                            width: 3rem
                            height: 2px
                            background: white
                            bottom: -0.5rem
                            left: 0


    .menu-profiles
        .menu-generic__container__left
            background: $color-base-dark

    @import ./sticky
    @import ./mobile
    @import ./profiles

</style>

<script>
    import $ from 'jquery'
    import throttle from 'lodash/throttle'


    export default {

        mounted: function() {
            this.$menu = $(this.$el).find('.menu-generic__container__right__wrapper');
            this.$sectionLinks = $(this.$el).find('.menu-generic__container__left__links a');
            this.$section = $(this.$el).find('.menu-generic__container__right');
            this.manageSticky();
            $(window).on("MenuGeneric:close", () => {
                this.close();
            });

            if(!!document.querySelector('.menu-local')) {
                const ml = document.querySelector('.menu-local');
                const btn = ml.querySelector('.menu-local--btn');

                if (ml.classList.contains('menu-initialized')) {
                  return;
                }

                ml.classList.add('menu-initialized');

                btn.addEventListener('click', function (){
                    ml.classList.toggle('visible');

                    if(ml.classList.contains('visible')) {
                        btn.ariaExpanded = 'true';
                    } else {
                        btn.ariaExpanded = 'false';
                    }
                });
            }
        },

        methods: {

            /**
             *
             */
            manageSticky: function() {
                let isMobile = ( $(window).width() <= 460 ); // TODO Handle on resize

                let debounce = throttle(() => {
                    this.close();

                    if ( $(window).scrollTop() > $(this.$el).height() ) {
                        $(this.$el).addClass('sticky');
                    } else {
                        $(this.$el).removeClass('sticky');
                    }
                }, 100);

                if ( !isMobile && $('.page-type-homepage_part, .page-type-homepage_pro').length ) {
                    $(document).on('scroll', () => {
                        debounce()
                    });
                    debounce();
                } else {
                    $(this.$el).addClass('sticky');
                }

            },

            /**
             *
             * @param index
             */
            open: function(index) {
                if ( this.$section.filter('.show').length ) {
                    this._hideAllContent();
                    if ( this.$sectionLinks.filter('.active').index() !== index )
                        this._showSection(index);
                    else
                        this._hideAllSections();
                } else {
                    this._showSection(index);
                }

            },

            /**
             *
             * @param index
             */
            close: function() {
                this._hideAllContent();
                this._hideAllSections();
            },

            /**
             *
             * @param index
             * @private
             */
            _showSection(index) {
                this.$sectionLinks.removeClass('active');
                this.$sectionLinks.eq(index).addClass('active');
                this.$section.addClass('show');
                let $menuItem = this.$menu.eq(index);
                $("body").addClass("menu-generic--section");
                this._showContent($menuItem);
                $('.node-homepage__shortcut').hide();
            },

            /**
             *
             * @private
             */
            _hideAllSections() {
                this.$sectionLinks.removeClass('active');
                setTimeout(() => this.$section.removeClass('show'), 10);
                $("body").removeClass("menu-generic--section");
                $('.node-homepage__shortcut').show();
            },

            /**
             *
             * @param $elem
             * @private
             */
            _showContent: function($elem) {
                setTimeout(() => $elem.addClass('show-content'), 150);
            },

            /**
             *
             * @private
             */
            _hideAllContent: function() {
                this.$menu.removeClass('show-content');
            },

            /**
             *
             * @param $event
             */
            toggleMenu: function($event) {
                let $elem = $($event.target);
                $(".menu-generic__mobile__level1.open").not($elem).removeClass('open');
                $elem.toggleClass("open");
            }
        }

    }


</script>
